// extracted by mini-css-extract-plugin
export var wordContainer = "_o2-0";